'use client';

import React from 'react';

interface ShareAuditButtonProps {
    title: string;
}

export default function ShareAuditButton({ title }: ShareAuditButtonProps) {
    const handleShare = () => {
        const text = `I just calculated/formatted ${title} on CorpToolset. Zero-knowledge local processing.`;
        const url = window.location.href;
        navigator.clipboard.writeText(`${text} ${url}`);
        alert('Tool link copied to clipboard! (Zero-Knowledge Safe)');
    };

    return (
        <button
            onClick={handleShare}
            style={{
                padding: '0.75rem 1.5rem',
                background: '#0f172a',
                color: '#fff',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: '0.85rem',
                border: 'none',
                cursor: 'pointer'
            }}
            className="hover-lift"
        >
            🔗 Share Tool Link
        </button>
    );
}
